<template>
  <div class="right-wrap">
    <div class="right-item" style="margin-right: 25px; position: relative" v-if="showExport">
      <slot name="export">
        <a-button :loading="loading" type="primary" @click="exportAsExcel" style="position: absolute; top: -20px; right: 2px;">{{ $t('buttons.export') }}</a-button>
      </slot>
    </div>
    <a-dropdown :trigger="['click']">
      <a class="ant-dropdown-link" @click="e => e.preventDefault()">
        {{ username }} <a-icon type="down" />
      </a>
      <a-menu slot="overlay">
        <a-menu-item>
          <a-button type="link" @click="logout" size="small" style="width: 100%; text-align: center">{{ $t('buttons.logout') }}</a-button>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { exportWarningList } from "@/api/warning"

export default {
  name: 'HeaderRight',
  data () {
    return {
      username: localStorage.getItem('nick') || '',
      isButtonShow: false,
      loading: false
    }
  },
  computed: {
    showExport () {
      const path = this.$route.path
      if (path.startsWith('/maintain')) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('rToken')
      this.$store.commit('resetTags')
      this.$store.commit('setWarnDeviceFlag', true)
      sessionStorage.removeItem('currentWT')
      localStorage.setItem('logout', '1')
      this.$router.replace('/login')
    },
    exportAsExcel() {
      this.exportData({
        query: [],
        filter: [],
        sort: []
      })
    },
    async exportData (req) {
      this.loading = true
      try {
        const { data } = await exportWarningList({
          latest: true,
          type: "MAINTAIN",
          lang: "zh-CN"
        }, req)
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const timestamp = new Date().getTime()
        link.download = timestamp + '.xlsx'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success(this.$t('messages.es'), 1)
      } catch(e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
  .right-wrap {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  .right-item {
    width: 55px;
    height: 100%;
    margin: 0 5px;
    cursor: pointer;
    text-align: center;
  }
  .right-item:hover{
    background-color: rgba(253, 252, 252, 0.5);
  }
</style>
